import { render, staticRenderFns } from "./ExpertMPT.vue?vue&type=template&id=d4a84b32&scoped=true"
import script from "./ExpertMPT.vue?vue&type=script&lang=js"
export * from "./ExpertMPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a84b32",
  null
  
)

export default component.exports